import type { FaireProductEntity } from "../../entity_types/product";

export const p_m7nkuj9gg6: FaireProductEntity = {
  token: "p_m7nkuj9gg6",
  type: "product",
  name: "CZ Enamel Tarot Charm 18K Gold Plated S.Steel Necklace - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/78e8038b8a9003e8d175a26abb37ce9b71746dcfd251a8c8812a1d53a3b5a6d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/91938291d998b595380b4151312175495aa34337fa8326d75f28b3b8ea21fb32.jpeg",
    "https://cdn.faire.com/fastly/8314366549876aede4b07adc3501d8dda224cede73eac9ac3e966406bff9f082.jpeg",
    "https://cdn.faire.com/fastly/96a04e3f4d465370b1e4e8364671778563e52101b785a13895342f044c64e0df.jpeg",
    "https://cdn.faire.com/fastly/a04b8c5c6337aefe58227ee1fcd7dc9cd92cd292b94c83a823c6b38a92b257b4.jpeg",
    "https://cdn.faire.com/fastly/ad3e15c335f7d9155005b446a3d5167b75a8dc95c405581f00aef2fec7b2313c.jpeg",
    "https://cdn.faire.com/fastly/3cfbeae4d704ece8c869c29a4b3860670ea008f2f32a3992f33a25ca12944153.jpeg",
    "https://cdn.faire.com/fastly/3742b30cdfcd30c1762812267233f7ac583c46183df503349e7538ef9f5a3bc2.jpeg",
    "https://cdn.faire.com/fastly/58000ab67f4f79475a6be3b4f19a631c48356d635be2edc110bf198e5852a1a7.jpeg",
    "https://cdn.faire.com/fastly/ba658bd4b36ce440148991b044b9a9115f50bcc0e701894e573ba9a696d2550a.jpeg",
  ],
  priceDollars: 8.18,
  description:
    "Type: pendant necklace\nMaterial: Stainless steel ，Cubic zirconia，Enamel，18K gold plated\nSize of pendant ： 14mm * 23mm\nLength of chain ： 400mm + 50mm\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 19.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:46.607Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
